import requestSC from "@/utils/requestSC";
import bestsign from "@/views/treaty/bestsign_content";
import requestApi from "@/utils/requestApi";
// import qs from "qs";

// eslint-disable-next-line no-unused-vars
import { decode } from "js-base64";

export default {
  name: "contract_sign",
  components: {
    bestsign,
  },
  data() {
    return {
      // 订单Id
      orderId: "",
      // 订单信息
      order: {},
      // 合同信息
      contractInfo: [],
      // 合同信息, pc端合同url, 支持下载
      contractInfoPc: [],
      contractInfoIndex: 0,
      contractTemplateName: "",
      //是否是卖家
      isSeller: "false",
      // 请先勾选同意《上上签服务协议》
      isSignTreaty: false,
      // 上上签服务协议名称
      bestsignAgreementName: "上上签服务协议",
      // 上上签服务协议链接
      bestsignAgreementUrl: "",
      // 上上签服务协议显示&隐藏
      bestsignContentVisible: false,
      // 合同显示&隐藏
      contractVisible: false,
      // 是否显示关闭按钮
      isShowClose: true,
      // 是否全屏显示
      isFullscreen: false,
      // 是否显示前往订单详情
      isShowOrderButton: false,
      // 是否显示签署合同
      buildContractVisible: false,
      // iframe域名相同不刷新
      iframeVisible: true,
      // 是否需要企业授权书
      isAuthFile: false,
      // 企业授权书提醒弹框
      authFileDialogVisible: false,
      // 认证相关
      authPcUrl: "",
      isAuth: true,
      tips: "",
    };
  },
  methods: {
    async getContractData(orderId, isSeller, order, isShowClose, isFullscreen, isShowOrderButton) {
      this.contractInfoIndex = 0;
      this.contractTemplateName = "";
      this.bestsignAgreementName = "上上签服务协议";
      this.bestsignAgreementUrl = "";
      this.isAuthFile = false;
      this.authFileDialogVisible = false;
      this.authPcUrl = "";
      this.isAuth = true;
      this.tips = "";
      this.contractVisible = false;
      this.isShowOrderButton = isShowOrderButton || false;
      this.isFullscreen = isFullscreen || false;
      this.isShowClose = isShowClose;
      this.isSeller = isSeller;
      this.order = order;
      this.orderId = orderId;
      this.previewContractVisible = true;
      this.buildContractVisible = order.buildContractVisible || false;

      const loading = this.$loading({
        lock: true,
        text: "加载中",
      });
      const { msg, code, data } = await requestSC.post("rest/contract/previewAgreement/v2", { invoiceContractType: "order", orderId });
      if (code == "403003" || code == "403006") {
        loading.close();
        this.$confirm(code == "403006" ? "企业未认证，无法完成合同签署" : "个人未实名，无法完成合同签署", "提示", {
          confirmButtonText: code == "403006" ? "去认证" : "去实名",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            if (code == "403006") {
              window.open(`${data.jrPcUrl}/v/accountAsset/balance/entBindCard?retUrl=${window.location.href}`);
            } else {
              window.open(`${data.jrPcUrl}/v/accountAsset/balance/certification?retUrl=${window.location.href}`);
            }
          })
          .catch();
        return;
      }

      if (code != "0") {
        loading.close();
        this.$message.error(msg);
        return;
      }

      const basicCaUrl = isSeller ? "sctrading/contract/mj/getBasicCa" : "sctrading/contract/getBasicCa";
      const { msg: contractMsg, code: contractCode, data: contractData } = await requestApi.post(basicCaUrl, {
        returnUrl: isSeller ? `${process.env.VUE_APP_APP}v/order/detailSeller/${this.orderId}` : `${process.env.VUE_APP_APP}v/order/detail/${this.orderId}`,
        orderId: this.orderId,
        contractType: "order",
      });
      loading.close();

      if (contractCode != "0") {
        this.$message.error(contractMsg);
        return;
      }
      const { name, url, isAuthFile, authPcUrl, isAuth, tips,isExpired } = contractData;
      console.log("contractData url: ", url);
      if (isAuth && !isExpired) {
        window.location.href = url;
        return;
      }
      this.authPcUrl = authPcUrl || "";
      this.isAuth = isAuth;
      this.tips = tips || "";
      if (name) {
        this.bestsignAgreementName = name;
      }
      if (url) {
        this.bestsignAgreementUrl = url;
      }
      this.isAuthFile = !!isAuthFile;

      this.contractInfo = data || [];
      this.contractVisible = true;
      this.contractTemplateName = data[0].contractUrl;
    },

    // 查看合同
    viewContract(data) {
      this.contractInfoIndex = 0;
      this.isShowOrderButton = false;
      this.isFullscreen = false;
      this.isShowClose = true;
      this.buildContractVisible = false;
      this.contractVisible = true;
      if (!data.contractInfoList || data.contractInfoList.length === 0) {
        this.getContractInfo(data.orderId);
        this.getContractInfoPc(data.orderId);
        return;
      }
      this.contractTemplateName = data.contractInfoList[0].contractUrl;
      this.contractInfo = data.contractInfoList;
    },

    // 获取合同信息
    getContractInfo(orderId) {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
      });
      this.$store
        .dispatch("orderTo/index/getContractInfo", {
          orderId: orderId,
        })
        .then((data) => {
          loading.close();
          if (data && data.length > 0) {
            this.contractTemplateName = data[0].contractUrl;
            this.contractInfo = data;
            console.log("this.contractInfo: ", this.contractInfo);
          }
        });
    },

    // 获取合同信息
    getContractInfoPc(orderId) {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
      });
      this.$store
        .dispatch("orderTo/index/getContractInfo", {
          orderId: orderId,
          queryFrom: "COMPUTER",
        })
        .then((data) => {
          loading.close();
          if (data && data.length > 0) {
            this.contractInfoPc = data;
            console.log("this.contractInfoPc: ", this.contractInfoPc);
          }
        });
    },

    // 下载 PDF 文件
    downloadPDF: function () {
      let urlParams = new URLSearchParams(this.contractInfo[this.contractInfoIndex].contractUrl.split("?")[1]);
      const params = {};
      for (const [key, value] of urlParams.entries()) {
        params[key] = value;
      }
      window.open(decodeURIComponent(decode(params.url)));
    },

    downloadPDFSigned: function () {
      window.open(this.contractInfoPc[this.contractInfoIndex].contractUrl);
    },

    buildContract() {
      this.bestsignContentVisible = false;
      if (!this.checkIsAuth()) {
        return;
      }
      if (this.bestsignAgreementUrl) {
        this.isSignTreaty = true;
        this.tryOpenAgreementUrl();
        return;
      }

      this.signContract();
    },
    async signContract() {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
      });
      const { msg, code, data } = await requestSC.post("rest/contract/signAgreement", {
        invoiceContractType: "order",
        orderId: this.orderId,
        isSeller: this.isSeller,
      });
      loading.close();
      if (code == "403003" || code == "403006") {
        this.$confirm(code == "403006" ? "企业未认证，无法完成合同签署" : "个人未实名，无法完成合同签署", "提示", {
          confirmButtonText: code == "403006" ? "去认证" : "去实名",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            if (code == "403006") {
              window.open(`${data.jrPcUrl}/v/accountAsset/balance/entBindCard?retUrl=${window.location.href}`);
            } else {
              window.open(`${data.jrPcUrl}/v/accountAsset/balance/certification?retUrl=${window.location.href}`);
            }
          })
          .catch();
        return;
      }

      if (code != "0") {
        this.$alert(msg, '提示', {
          confirmButtonText: '确定',
          callback: action => {
            if (this.isFullscreen) {
              this.toOrderDetail();
            }
          }
        });
        return;
      }

      if (!this.isSeller) {
        this.$store
          .dispatch("orderTo/index/selButtonDetailByOrderId", {
            orderId: this.orderId,
          })
          .then((res) => {
            this.$emit("loadOrder");
            this.order.orderId = this.orderId;
            const buttonList = res.find((item) => item.buttonName == "去支付");
            if (buttonList) {
              this.$emit("buttonSubmit", buttonList, this.order);
            }
          });
      } else {
        this.$emit("loadOrder");
      }
      this.contractVisible = false;
    },
    toOrderDetail() {
      window.location.href = `/v/order/detail/${this.orderId}`;
    },
    openAgreementUrl() {
      if (this.bestsignAgreementUrl) {
        window.location.href = this.bestsignAgreementUrl;
      }
    },
    tryOpenAgreementUrl() {
      if (this.isAuthFile) {
        this.authFileDialogVisible = true;
        return;
      }
      this.openAgreementUrl();
    },
    onAuthFileReady() {
      this.authFileDialogVisible = false;
      this.openAgreementUrl();
    },
    onSignTreatyChange(val) {
      if (val) {
        this.tryOpenAgreementUrl();
      }
    },
    checkIsAuth() {
      if (this.isAuth === false || this.isAuth === "false") {
        this.$confirm(this.tips || "请先完成认证", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            if (this.authPcUrl) {
              const separator = this.authPcUrl.includes("?") ? "&" : "?";
              window.location.href = `${this.authPcUrl}${separator}retUrl=${encodeURIComponent(window.location.href)}`;
            }
          })
          .catch();
        return false;
      }
      return true;
    },
    tabClick(item) {
      this.iframeVisible = false;
      this.contractInfoIndex = Number(item.index);
      this.$nextTick(() => {
        this.iframeVisible = true;
      });
    },
  },
};
